//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// schedule-range-picker imports
import * as s from "./ScheduleRangePicker.styles";
import { IProps } from "./ScheduleRangePickerTypes";
// state
import { EScheduleRange } from "#webapp/src/util/scheduler.util";
// material-ui
import { Select, SelectOption } from "@clockwise/design-system";
import { DateRange } from "@clockwise/design-system/icons";
import { Divider } from "@material-ui/core";

//////////////////
// SETUP
//////////////////
const commonOptions = [
  { value: EScheduleRange.Today, primaryText: "Today" },
  { value: EScheduleRange.Tomorrow, primaryText: "Tomorrow" },
  { value: EScheduleRange.ThisWeek, primaryText: "This week" },
];

const quickSchedulerOptions = [
  ...commonOptions,
  { value: EScheduleRange.NextTwo, primaryText: "Soon" },
  { value: EScheduleRange.NextWeek, primaryText: "Next Week" },
  { value: EScheduleRange.CurrentView, primaryText: "Current calendar view" },
];

const reschedulerOptions = [
  ...commonOptions,
  { value: EScheduleRange.CurrentView, primaryText: "Within a few days" },
  { value: EScheduleRange.NextWeek, primaryText: "Next Week" },
];

const createEventOptions = [
  ...commonOptions,
  { value: EScheduleRange.NextTwo, primaryText: "Soon" },
  { value: EScheduleRange.CurrentView, primaryText: "Selected Date" },
];

const feedSchedulerBaseOptions = [
  { value: EScheduleRange.Today, primaryText: "Today" },
  { value: EScheduleRange.Tomorrow, primaryText: "Tomorrow" },
  { value: EScheduleRange.CurrentView, primaryText: "Within a few days" },
  { value: EScheduleRange.NextSeven, primaryText: "Within a week" },
  // { value: EScheduleRange.NextWeek, primaryText: 'Next Week' },
  { value: "", primaryText: "" },
  { value: `generic-${EScheduleRange.AroundDate}`, primaryText: "Around a date" },
  { value: `generic-${EScheduleRange.SpecificDate}`, primaryText: "On a date" },
];

const constructFeedSchedulerOptions = (props?: IProps) => {
  const options = [...feedSchedulerBaseOptions]; // base options

  // maybe add currently selected date bound options
  if (props && props.selectedAroundDateLabel) {
    options.splice(5, 0, {
      value: EScheduleRange.AroundDate,
      primaryText: `Around ${props.selectedAroundDateLabel}`,
    });
  }

  if (props && props.selectedDateLabel) {
    options.splice(5, 0, {
      value: EScheduleRange.SpecificDate,
      primaryText: `On ${props.selectedDateLabel}`,
    });
  }

  return options;
};

//////////////////
// COMPONENT
//////////////////
export class ScheduleRangePicker extends React.Component<IProps> {
  private feedSchedulerOptions = constructFeedSchedulerOptions();

  constructor(props: IProps) {
    super(props);
    this.feedSchedulerOptions = constructFeedSchedulerOptions(props);
  }

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    this.feedSchedulerOptions = constructFeedSchedulerOptions(nextProps);
  }

  private onChangeRange = (range: EScheduleRange) => {
    const dateRestrictedRange = range.split("generic-")[1];
    if (dateRestrictedRange) {
      return this.props.onChange(dateRestrictedRange as EScheduleRange);
    } else if (range === EScheduleRange.AroundDate || range === EScheduleRange.SpecificDate) {
      return;
    }
    return this.props.onChange(range);
  };

  public render() {
    const options = this.props.rescheduler
      ? reschedulerOptions
      : this.props.createEvent
      ? createEventOptions
      : this.props.quickScheduler
      ? quickSchedulerOptions
      : this.feedSchedulerOptions;

    return (
      <div style={{ ...s.container, ...this.props.style }}>
        {!this.props.hideIcon ? <DateRange style={s.icon} htmlColor={s.icon.color} /> : ""}
        <Select
          value={this.props.selectedRange}
          onChange={this.onChangeRange}
          name="Range"
          cw-id={this.props["cw-id"]}
        >
          {options.map((opt, i) => {
            if (!opt.value && !opt.primaryText) {
              return <Divider key={`schedule-range-picker-${i}`} />;
            }
            return (
              <SelectOption key={opt.value} value={opt.value}>
                {opt.primaryText}
              </SelectOption>
            );
          })}
        </Select>
      </div>
    );
  }
}
